export { SpaPackageModalConnected as SpaPackageModal } from './container';
